"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Alarms = function Alarms(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.89,20.34A1.32,1.32,0,0,1,18.57,19V15.11a6.05,6.05,0,0,0-3.49-5.49,2.59,2.59,0,0,0-5.15,0,6.05,6.05,0,0,0-3.49,5.5V19a1.32,1.32,0,0,1-1.32,1.32.42.42,0,1,0,0,.83h5.28a2.15,2.15,0,0,0,4.23,0h5.28a.42.42,0,1,0,0-.83Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.11,10.31a.42.42,0,0,1-.42-.42,5.21,5.21,0,0,1,5.2-5.2.42.42,0,1,1,0,.83A4.37,4.37,0,0,0,5.53,9.89.42.42,0,0,1,5.11,10.31Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.5,10.31a.42.42,0,0,1-.42-.42A7.82,7.82,0,0,1,9.89,2.08a.42.42,0,1,1,0,.83,7,7,0,0,0-7,7A.42.42,0,0,1,2.5,10.31Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.89,10.31a.42.42,0,0,1-.42-.42,4.37,4.37,0,0,0-4.37-4.37.42.42,0,1,1,0-.83,5.21,5.21,0,0,1,5.2,5.2A.42.42,0,0,1,19.89,10.31Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.5,10.31a.42.42,0,0,1-.42-.42,7,7,0,0,0-7-7,.42.42,0,1,1,0-.83,7.82,7.82,0,0,1,7.81,7.81A.42.42,0,0,1,22.5,10.31Z"
  }));
};

var _default = Alarms;
exports["default"] = _default;